import { render, staticRenderFns } from "./Taxes.vue?vue&type=template&id=79962e73"
import script from "./Taxes.vue?vue&type=script&lang=ts"
export * from "./Taxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79962e73')) {
      api.createRecord('79962e73', component.options)
    } else {
      api.reload('79962e73', component.options)
    }
    module.hot.accept("./Taxes.vue?vue&type=template&id=79962e73", function () {
      api.rerender('79962e73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/Taxes.vue"
export default component.exports